function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import cn from 'classnames';
import { formatTimestamp } from 'helpers/datetime';
import intlShape from 'shapes/intlShape';
import styles from './VisitNotes.pcss';
var _React_PureComponent;
class VisitNoteHeader extends (_React_PureComponent = React.PureComponent) {
    renderNoteHeaderDateRange(payload) {
        const { start, end } = payload;
        if (!start && !end) {
            return null;
        }
        const startDate = formatTimestamp(start) || '';
        const endDate = formatTimestamp(end) || '';
        let dateRange = '(';
        if (startDate) dateRange += startDate;
        if (startDate && endDate) dateRange += ' - ';
        if (endDate) dateRange += endDate;
        dateRange += ')';
        return /*#__PURE__*/ _jsx("span", {
            className: styles.note__header__dateRange,
            children: dateRange
        });
    }
    renderNoteValue(payload) {
        const { value, standardDeviation, unitSymbol } = payload;
        const hasValue = value !== null && value !== undefined;
        const hasUnitSymbol = unitSymbol !== null && unitSymbol !== undefined;
        if (!hasValue && !hasUnitSymbol) {
            return null;
        }
        let noteValue = hasValue ? `${value}` : 'N/A';
        const hasStdDev = standardDeviation !== null && standardDeviation !== undefined;
        if (hasStdDev) noteValue += `\u00b1${standardDeviation}`;
        if (unitSymbol && hasValue) noteValue += unitSymbol;
        return /*#__PURE__*/ _jsx("span", {
            dir: "ltr",
            children: noteValue
        });
    }
    render() {
        const { payload } = this.props.note;
        if (!payload) {
            return null;
        }
        const { titleMessage, rangeValue, value, unitSymbol, status } = payload;
        const hasValue = value !== null && value !== undefined;
        const hasUnitSymbol = unitSymbol !== null && unitSymbol !== undefined;
        const hasRangeValue = rangeValue !== null && rangeValue !== undefined;
        let noteHeader = titleMessage ? this.props.intl.formatMessage(titleMessage) : '';
        if (hasRangeValue) noteHeader += ` (${rangeValue})`;
        if (hasValue || hasUnitSymbol) noteHeader += ': ';
        return /*#__PURE__*/ _jsxs("h3", {
            className: cn(styles.note__header, {
                [styles[`note__header--${status}`]]: status
            }),
            children: [
                noteHeader,
                this.renderNoteValue(payload),
                this.renderNoteHeaderDateRange(payload)
            ]
        });
    }
}
_define_property(VisitNoteHeader, "propTypes", {
    // Explicit props
    note: PropTypes.shape({
        payload: PropTypes.object
    }),
    // Implicit props
    intl: intlShape
});
export default injectIntl(VisitNoteHeader);
